import {
  createContext,
  useState,
  FunctionComponent,
  useContext,
  useCallback,
  useMemo,
} from 'react'
import { getCache } from '@/utils/cache'
import { ClinicAndFlags, IClinic } from '@/modules/Auth/auth-types'
import {
  buildSpecialitiesFromClinic,
  Speciality,
} from '@/modules/MedicalSpecialities/classes/Speciality'

export interface IMedicalSpecialitiesContext {
  specialities?: Speciality[]
  setSpecialities(clinic: IClinic): void
}

const MedicalSpecialitiesContext =
  createContext<IMedicalSpecialitiesContext>(null)

export const MedicalSpecialitiesProvider: FunctionComponent = ({
  children,
}) => {
  const [specialities, setSpecialities] = useState<Speciality[]>(() => {
    const clinicAndFlags = getCache<ClinicAndFlags>('clinic')
    if (clinicAndFlags) {
      return buildSpecialitiesFromClinic(clinicAndFlags.clinic)
    }
    return []
  })

  const setSpecialityByClinic = useCallback((clinic: IClinic): void => {
    setSpecialities(buildSpecialitiesFromClinic(clinic))
  }, [])

  const medicalSpecialitiesProviderValue = useMemo(() => {
    return { specialities, setSpecialities: setSpecialityByClinic }
  }, [setSpecialityByClinic, specialities])

  return (
    <MedicalSpecialitiesContext.Provider
      // value={{ specialities, setSpecialities: setSpecialityByClinic }}
      value={medicalSpecialitiesProviderValue}
    >
      {children}
    </MedicalSpecialitiesContext.Provider>
  )
}

export const useMedicalSpecialitiesContext =
  (): IMedicalSpecialitiesContext => {
    const context = useContext(MedicalSpecialitiesContext)
    if (!context) {
      throw new Error(
        'useAuthContext must be used within a MedicalSpecialitiesProvider',
      )
    }
    return context
  }
